
export const CURRENT_VERSION = process.env.REACT_APP_VERSION;
export const LOCAL_STORAGE_KEYS = {
    auth_token: 'dq_admin_auth_token',
    auth_user: 'dq_admin_auth_user',
    refresh_token: 'dq_admin_refresh_token',
    e2ee_krypto_pair_obj: 'dq_common_e2ee_krypto_objp',
    e2ee_krypto_disable_flg: 'dq_common_e2ee_disable_flg',
    qa_mode: 'dq_qa_mode'
}

export const USER_TYPE = {
    REGULAR: 10,
    SUPER_USER: 1,
    ADMIN_PORTAL: 2,
    ORG_PORTAL: 3
};

export const ORG_TYPE = {
    1: 'Default',
    2: 'Company',
    3: 'School'
}

export const USER_ACCESS_LEVEL = {
    NOT_APPLICABLE: 0,
    NO_ACCESS: 1,
    PARTIAL_ACCESS_ADMIN_PORTAL: 2,
    FULL_ACCESS_ADMIN_PORTAL: 3,
    FULL_ACCESS_ANALYTICS_PORTAL: 4,
    PARTIAL_ACCESS_ANALYTICS_PORTAL: 5,
};

export const USER_TYPE_VERBOSE = {
    10: 'REGULAR',
    1: 'SUPER_USER',
    2: 'ADMIN_PORTAL',
    3: 'ORG_PORTAL'
};

export const INSIDER_PROFILE_TYPE = {
    EDUCATOR: 'EDUCATOR',
    BUSINESS: 'BUSINESS',
    GUEST: 'GUEST',
}

export const INSIDER_PROFILE_TYPE_VERBOSE = {
    [INSIDER_PROFILE_TYPE.EDUCATOR]:   'Educator',
    [INSIDER_PROFILE_TYPE.BUSINESS]:   'Business',
    [INSIDER_PROFILE_TYPE.GUEST]:      'Guest',
};

export const USER_ACCESS_LEVEL_VERBOSE = {
    0: 'N/A',
    1: 'No Access',
    2: 'Partial Access (Admin)',
    3: 'Full Access (Admin)',
    4: 'Full Access (Analytics - Full Org)',
    5: 'Partial Access (Analytics)',
    6: 'Full Access (Analytics - Single Inst)'
};



export const NESTED_ACL_KEYS = {
    ORG_CRUD_REMOVE: 'admin_org_crud_remove',
    ORG_CRUD_CREATE: 'admin_org_crud_create',
    ORG_CRUD_UPDATE: 'admin_org_crud_update',
    ORG_ACCOUNTS_ADD: 'admin_org_accounts_add',
    ORG_ACCOUNTS_REMOVE: 'admin_org_accounts_remove',
    USERS_UPDATE_ENTITY: 'admin_users_update_entity',
    USERS_ADD: 'admin_users_add',
    USERS_REMOVE: 'admin_users_remove',
    PAC_MANAGE: 'admin_pac_manage',
}

export const LICENSES_ORDER_STATUS_VERBOSE = {
    0: 'Not Set',
    1: 'Pending',
    2: 'Approved',
    3: 'Rejected',
    4: 'Withdrawn'
}

export const LICENSES_ORDER_STATUS = {
    NOT_SET: 0,
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    WITHDRAWN: 4,
};

export const ORG_LICENSES_BILLING_STATUS = {
    PENDING: 1,
    PAID: 2,
    UNDER_REVIEW: 3,
};

export const ORG_LICENSES_BILLING_STATUS_VERBOSE = {
    1: 'Pending',
    2: 'Paid',
    3: 'Under Review'
};

export const DQ_PRO_PLAN_KEY = {
    DEFAULT:            'default',
    // GLOBAL_STANDARDS:   'global_standards',
    // BASELINE_AND_TEACH: 'baseline_and_teach',
    DQ_PRO:             'dq_pro',
    EDUCATOR:           'educator',
    ENTERPRISE:          'enterprise_plan',

};

export const DQ_PRO_PLAN_KEY_VERBOSE = {
    [DQ_PRO_PLAN_KEY.DEFAULT]:            'Default',
    // [DQ_PRO_PLAN_KEY.GLOBAL_STANDARDS]:   'Global Standards',
    // [DQ_PRO_PLAN_KEY.BASELINE_AND_TEACH]: 'Baseline & Teach',
    [DQ_PRO_PLAN_KEY.DQ_PRO]:             'DQ Pro',
    [DQ_PRO_PLAN_KEY.EDUCATOR]:           'Educator',
    [DQ_PRO_PLAN_KEY.ENTERPRISE]:          'Enterprise',
};

export const STRIPE_COLLECTION_METHOD = {
    CHARGE_AUTOMATICALLY: 'charge_automatically',
    SEND_INVOICE: 'send_invoice',
};

export const COLLECTION_METHOD_LABELS = {
    [STRIPE_COLLECTION_METHOD.CHARGE_AUTOMATICALLY]: 'Charge Automatically',
    [STRIPE_COLLECTION_METHOD.SEND_INVOICE]: 'Charge Manually',
};

export const STRIPE_SUBSCRIPTION_STATUS = {
    ACTIVE:             'active',
    INCOMPLETE:         'incomplete',
    PAST_DUE:           'past_due',
    CANCELLED:          'cancelled',
    TRIALING:           'trialing',
    UNPAID:             'unpaid',
};

export const STRIPE_SUBSCRIPTION_STATUS_VERBOSE = {
    [STRIPE_SUBSCRIPTION_STATUS.ACTIVE]:             'Active',
    [STRIPE_SUBSCRIPTION_STATUS.INCOMPLETE]:         'Incomplete',
    [STRIPE_SUBSCRIPTION_STATUS.PAST_DUE]:           'Past Due',
    [STRIPE_SUBSCRIPTION_STATUS.CANCELLED]:          'Cancelled',
    [STRIPE_SUBSCRIPTION_STATUS.TRIALING]:           'Trialing',
    [STRIPE_SUBSCRIPTION_STATUS.UNPAID]:             'Unpaid',
};


export const CREDIT_TRANSACTION_TYPE = {
    TOPUP:      'topup',
    DEDUCTION:  'deduction',
    REFUND:     'refund',
    ADJUSTMENT: 'adjustment',
};

export const CREDIT_TRANSACTION_TYPE_VERBOSE = {
    [CREDIT_TRANSACTION_TYPE.TOPUP]: 'Top-up',
    [CREDIT_TRANSACTION_TYPE.DEDUCTION]: 'Deduction',
    [CREDIT_TRANSACTION_TYPE.REFUND]: 'Refund',
    [CREDIT_TRANSACTION_TYPE.ADJUSTMENT]: 'Adjustment',
};


export const ACL_RESOURCE_KEYS = {
    ORGANIZATION_COLLECTION: 'organization_collection',
    ORG_ACCOUNTS: 'org_accounts',
    ORG_ORDERS: 'org_orders',
    ORG_ALLORDERS: 'org_allorders',
    ORG_CONFIGS: 'org_configs',
    BADGE_UI_CONFIG: 'badge_ui_config',
    MODULE_UI_CONFIG: 'module_ui_config',
    ORG_BADGES: 'org_badges',
    ORG_MODULES: 'org_modules',
    ORG_PACKS: 'org_packs',
    ORG_LICENSES_BILLING: 'org_licenses_billing',
    INSIDER_LIST: 'insider_list',
    INSIDER_DQ_MODULES: 'insider_dq_modules',
    INSIDER_CUSTOM_MODULES: 'insider_custom_modules',
    INSIDER_DQ_USER_GROUPS: 'insider_dq_user_groups',
    INSIDER_CUSTOM_USER_GROUPS: 'insider_custom_user_groups',
    INSIDER_LICENSE_ORDERS: 'insider_license_orders',
    INSIDER_LIST_ORG: 'insider_list_org',
    INSIDER_LIST_ORG_MODULES: 'insider_list_org_modules',
    VOUCHER_ALLOCATION: 'voucher_allocation',
    META_ASSESS_8: 'meta_assess_8',
    META_CATEGORY_4: 'meta_category_4',
    META_CATEGORY_11: 'meta_category_11',
    META_CATEGORY_108: 'meta_category_108',
    META_LEVEL_5: 'meta_level_5',
    META_LEVEL_6: 'meta_level_6',
    META_LEVEL_7: 'meta_level_7',
    META_LEVEL_9: 'meta_level_9',
    META_V3_LEVEL_1_AREA: 'meta_v3_level_1',
    META_V3_LEVEL_2_STAKEHOLDER: 'meta_v3_level_2',
    META_V3_LEVEL_3_DIMENSION: 'meta_v3_level_3',
    META_V3_LEVEL_5_COMPETENCY: 'meta_v3_level_5',
    META_V3_LEVEL_7_DQ_CODE: 'meta_v3_level_7',
    META_V3_LEVEL_8_UNIT: 'meta_v3_level_8',
    META_V3_LEVEL_9_SESSION: 'meta_v3_level_9',
    META_V3_LEVEL_10_ELEMENT: 'meta_v3_level_10',
    META_V3_LEVEL_11_RUBRIC: 'meta_v3_level_11',
    META_V3_INSTRUMENT_BANK: 'meta_v3_instrument_bank',
    META_PACKAGES: 'meta_packages',
    META_TRANSLATIONS_ASSESS_8: 'meta_translations_assess_8',
    META_TRANSLATIONS_LEVEL_5: 'meta_translations_level_5',
    META_TRANSLATIONS_LEVEL_6: 'meta_translations_level_6',
    META_TRANSLATIONS_V3_DQCODE: 'meta_translations_v3_dqcode',
    META_VOUCHERS: 'meta_vouchers',
    USERS: 'users',
    CONFIGS: 'configs',
    BUILDS: 'builds',
    PAC_PRODUCTS: 'pac_products',
    PAC_INSIDER_ACCESS: 'pac_insider_access',
}

export const ACL_ENABLE_ENDPOINTS = [
    'org/list',
    'org/accounts',
    'org/orders',
    'org/allorders',
    'org/configs',
    'org/area_ui_conf',
    'org/badge_ui_conf',
    'org/all_areas',
    'org/all_badges',
    'org/all_packages',
    'org/vouchers',

    'insider/list',
    'insider/dq_modules',
    'insider/custom_modules',
    'insider/user_groups_system',
    'insider/user_groups_custom',
    'insider/license_orders',
    'insider/list_org',
    'insider/list_org_modules',

    'meta_data/assess8',
    'meta_data/cat4',
    'meta_data/cat11',
    'meta_data/cat108',
    'meta_data/level3',
    'meta_data/level6',
    'meta_data/level7',
    'meta_data/level9',
    'meta_data/v3_level1_area',
    'meta_data/v3_level2_stakeholder',
    'meta_data/v3_level3_dimension',
    'meta_data/v3_level5_competency',
    'meta_data/v3_level7_dq_code',
    'meta_data/v3_level8_unit',
    'meta_data/v3_level9_session',
    'meta_data/v3_level10_element',
    'meta_data/v3_level11_rubric',
    'meta_data/v3_instrument_bank',
    'meta_data/packages',
    'meta_data/assess8_translation',
    'meta_data/level3_translation',
    'meta_data/level6_translation',
    'meta_data/v3dqcode_translation',
    'meta_data/vouchers',

    'users/list',
    'settings/configs',
    'settings/builds',
    'pac/products',
    'pac/insider',
]
export const ACL_RESOURCE_ROUTES_MAP = {
    'org/list': ACL_RESOURCE_KEYS.ORGANIZATION_COLLECTION,
    'org/accounts': ACL_RESOURCE_KEYS.ORG_ACCOUNTS,
    'org/orders': ACL_RESOURCE_KEYS.ORG_ORDERS,
    'org/allorders': ACL_RESOURCE_KEYS.ORG_ALLORDERS,
    'org/configs': ACL_RESOURCE_KEYS.ORG_CONFIGS,

    'org/area_ui_conf': ACL_RESOURCE_KEYS.MODULE_UI_CONFIG,
    'org/badge_ui_conf': ACL_RESOURCE_KEYS.BADGE_UI_CONFIG,
    'org/all_areas': ACL_RESOURCE_KEYS.ORG_MODULES,
    'org/all_badges': ACL_RESOURCE_KEYS.ORG_BADGES,
    'org/all_packages': ACL_RESOURCE_KEYS.ORG_PACKS,
    'org/vouchers': ACL_RESOURCE_KEYS.VOUCHER_ALLOCATION,

    'insider/list': ACL_RESOURCE_KEYS.INSIDER_LIST,
    'insider/dq_modules': ACL_RESOURCE_KEYS.INSIDER_DQ_MODULES,
    'insider/custom_modules': ACL_RESOURCE_KEYS.INSIDER_CUSTOM_MODULES,
    'insider/dq_user_groups': ACL_RESOURCE_KEYS.INSIDER_DQ_USER_GROUPS,
    'insider/custom_user_groups': ACL_RESOURCE_KEYS.INSIDER_CUSTOM_USER_GROUPS,
    'insider/license_orders': ACL_RESOURCE_KEYS.INSIDER_LICENSE_ORDERS,
    'insider/list_org': ACL_RESOURCE_KEYS.INSIDER_LIST_ORG,
    'insider/list_org_modules': ACL_RESOURCE_KEYS.INSIDER_LIST_ORG_MODULES,

    'meta_data/assess8': ACL_RESOURCE_KEYS.META_ASSESS_8,
    'meta_data/cat4': ACL_RESOURCE_KEYS.META_CATEGORY_4,
    'meta_data/cat11': ACL_RESOURCE_KEYS.META_CATEGORY_11,
    'meta_data/cat108': ACL_RESOURCE_KEYS.META_CATEGORY_108,
    'meta_data/level3': ACL_RESOURCE_KEYS.META_LEVEL_5,
    'meta_data/level6': ACL_RESOURCE_KEYS.META_LEVEL_6,
    'meta_data/level7': ACL_RESOURCE_KEYS.META_LEVEL_7,
    'meta_data/level9': ACL_RESOURCE_KEYS.META_LEVEL_9,
    'meta_data/v3_level1_area': ACL_RESOURCE_KEYS.META_V3_LEVEL_1_AREA,
    'meta_data/v3_level2_stakeholder': ACL_RESOURCE_KEYS.META_V3_LEVEL_2_STAKEHOLDER,
    'meta_data/v3_level3_dimension': ACL_RESOURCE_KEYS.META_V3_LEVEL_3_DIMENSION,
    'meta_data/v3_level5_competency': ACL_RESOURCE_KEYS.META_V3_LEVEL_5_COMPETENCY,
    'meta_data/v3_level7_dq_code': ACL_RESOURCE_KEYS.META_V3_LEVEL_7_DQ_CODE,
    'meta_data/v3_level8_unit': ACL_RESOURCE_KEYS.META_V3_LEVEL_8_UNIT,
    'meta_data/v3_level9_session': ACL_RESOURCE_KEYS.META_V3_LEVEL_9_SESSION,
    'meta_data/v3_level10_element': ACL_RESOURCE_KEYS.META_V3_LEVEL_10_ELEMENT,
    'meta_data/v3_level11_rubric': ACL_RESOURCE_KEYS.META_V3_LEVEL_11_RUBRIC,
    'meta_data/v3_instrument_bank': ACL_RESOURCE_KEYS.META_V3_INSTRUMENT_BANK,
    'meta_data/packages': ACL_RESOURCE_KEYS.META_PACKAGES,
    'meta_data/assess8_translation': ACL_RESOURCE_KEYS.META_TRANSLATIONS_ASSESS_8,
    'meta_data/v3dqcode_translation': ACL_RESOURCE_KEYS.META_TRANSLATIONS_V3_DQCODE,
    'meta_data/level3_translation': ACL_RESOURCE_KEYS.META_TRANSLATIONS_LEVEL_5,
    'meta_data/level6_translation': ACL_RESOURCE_KEYS.META_TRANSLATIONS_LEVEL_6,
    'meta_data/vouchers': ACL_RESOURCE_KEYS.META_VOUCHERS,

    'users/list': ACL_RESOURCE_KEYS.USERS,
    'settings/configs': ACL_RESOURCE_KEYS.CONFIGS,
    'settings/builds': ACL_RESOURCE_KEYS.BUILDS,
    'pac/products': ACL_RESOURCE_KEYS.PAC_PRODUCTS,
    'pac/insider': ACL_RESOURCE_KEYS.PAC_INSIDER_ACCESS,
}

export const PRODUCT_KEY = {
    LEARNING_PROGRAM:         'learning_program',
    ASSESSMENT:               'assessment',
    CPC_INDEX_ASSESSMENT:     'cpc_index_assessment',
    STARS_ALIGNMENT:          'stars_alignment',
    FRAMEWORK_CREATOR:        'framework_creator',
    IMPACT_DASHBOARD:         'impact_dashboard',
};

/** PAC v3 — non-product platform capabilities (features). */
export const FEATURE_KEY = {
    WHITE_LABEL_BRANDING: 'white_label_branding',
    API_ACCESS:           'api_access',
    LOCALIZATION:         'localization',
    ADVANCED_ANALYTICS:   'advanced_analytics',
    PLATFORM_MODE:        'platform_mode',
};

export const PAC_SOURCE_VERBOSE = {
    insider_override:      'Insider Override',
    org_override:          'Org Override',
    default_disabled:      'Default (Disabled)',
    global_disabled:       'Global Disabled',
    subscription_inactive: 'Subscription Inactive',
};
/*
 * Organisation type and primary role / activity — the sign-up registry's pick
 * lists, as the platform codes my-dq-api stores (ORGANIZATION_TYPE_CODE and
 * PRIMARY_ACTIVITY_CODE in its utils/constants.js). Labels match the sign-up
 * chatbot's wording.
 */
export const ORGANIZATION_TYPE_OPTIONS = [
    { value: 'private_company',             label: 'Private company / business' },
    { value: 'nonprofit_ngo_foundation',    label: 'Nonprofit / NGO / foundation' },
    { value: 'government_public_sector',    label: 'Government / public sector agency' },
    { value: 'school_or_school_network',    label: 'School / school network' },
    { value: 'university_higher_education', label: 'University / higher education institution' },
    { value: 'international_multilateral',  label: 'International / multilateral organization' },
    { value: 'independent_professional',    label: 'Independent professional / sole practitioner' },
    { value: 'other',                       label: 'Other (please specify)' },
];

export const PRIMARY_ACTIVITY_OPTIONS = [
    { value: 'education_training_provider',  label: 'Education / training provider' },
    { value: 'consultancy_advisory',         label: 'Consultancy / advisory' },
    { value: 'technology_platform_provider', label: 'Technology / platform provider' },
    { value: 'research_academic',            label: 'Research / academic' },
    { value: 'government_policy',            label: 'Government / policy' },
    { value: 'school_delivery',              label: 'School delivery' },
    { value: 'program_provider',             label: 'Program provider' },
    { value: 'funder_sponsor',               label: 'Funder / Sponsor' },
    { value: 'other',                        label: 'Other' },
];
